import { Flex, Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { formatDate } from '@blockpulse3/helpers';

type Props = {
  date: Date;
  documentType: string;
};

export function DocumentReset({ date, documentType }: Props): JSX.Element {
  const i18nSubscriberDetailsSidePanel = useTranslations('SubscriberDetailsSidePanel');
  const i18nDocumentValues = useTranslations('DocumentValues');

  const documentNameKeyMap: Record<string, string> = {
    SUBSCRIPTION: i18nDocumentValues('DocumentSUBSCRIPTION'),
  };

  return (
    <Stack spacing={1}>
      <Text fontSize="sm">
        {i18nSubscriberDetailsSidePanel.rich('Activity.DocumentReset.Title', {
          documentName: documentNameKeyMap[documentType],
          important: (chunks) => (
            <Text as="span" fontWeight="600">
              {chunks}
            </Text>
          ),
        })}
      </Text>
      <Flex color="gray.500" justifyContent="space-between">
        <Text>{i18nSubscriberDetailsSidePanel('Activity.DocumentReset.Date')}:</Text>
        <Text>{formatDate(date, 'DD/MM/YYYY')}</Text>
      </Flex>
    </Stack>
  );
}

export type DocumentResetProps = Props;
